<!-- <p *ngIf="client">{{client.organization.name}} wants to access the following scopes</p>
<p>{{scopes}}</p>

<button (click)="authorize()">Authorize</button> -->
<div class="loader">
    <mat-spinner></mat-spinner>
</div>